import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const qualityCheckSlice = createApi({
    reducerPath: "qualityCheck",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        qualityCheck: builder.mutation({
            query: (data) => ({ url: "/inventory/api/v1/qualitycheck/create", method: "POST", body: data }),
        }),
    }),
});

export const { useQualityCheckMutation } = qualityCheckSlice;
